import React from 'react';
import styled from 'styled-components';
import Label from './Label';
import Error from './Error';
import useInputMask from '../../../hooks/useInputMask';

interface Props {
  label: string;
  type?: string;
  name: string;
  value: any;
  id: string;
  error?: string;
  onChange: (name: string, value: string) => void;
  onBlur: (name: string, value: string) => void;
}

const InputMask = ({ onChange, onBlur, label, type = 'string', name, value, id, error }: Props) => {
  const { Widget } = window;
  const { hasValue, focused, handleBlur, handleFocus, handleChange } = useInputMask({
    id,
    value,
    onChange,
    lang: Widget.settings.lang,
  });

  const handleBlurInput = () => {
    handleBlur();
    if (onBlur) onBlur(name, value);
  };

  return (
    <Wrapper>
      <Label active={hasValue || focused}>{label}</Label>
      <StyledInput
        id={id}
        type={type}
        name={name}
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlurInput}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default InputMask;

const Wrapper = styled.label`
  display: block;
  position: relative;
`;

const StyledInput = styled.input<any>`
  width: 100%;
  height: 40px;
  padding: 8px;
  background: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
  direction: ${({ theme }) => (theme.phoneIsRtl ? 'rtl' : 'ltr')};

  &:hover {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  }

  &:focus {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.8);
  }
`;
